import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';

interface Snowflake {
  style: Record<string, string>;
}

@Component({
  selector: 'app-snow',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="snowflakes" aria-hidden="true">
      @for (flake of snowflakes(); track $index) {
        <div class="snowflake" [ngStyle]="flake.style">❅</div>
      }
    </div>
  `,
  styles: [
    `
      .snowflakes {
        position: fixed;
        inset: 0;
        pointer-events: none;
        z-index: 9999;
        overflow: hidden;
      }
      .snowflake {
        position: absolute;
        top: -2em;
        color: #abf0ff;
        animation-name: fall;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }
      @keyframes fall {
        0% {
          transform: translateY(0) rotate(0deg);
        }
        100% {
          transform: translateY(110vh) rotate(360deg);
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnowComponent implements OnInit {
  readonly snowflakes = signal<Snowflake[]>([]);

  ngOnInit() {
    this.generateSnowflakes();
  }

  private generateSnowflakes() {
    const count = 50; // Adjust number of snowflakes
    const flakes: Snowflake[] = [];

    for (let i = 0; i < count; i++) {
      const duration = Math.random() * 5 + 5 + 's'; // 5-10s
      const delay = Math.random() * 5 * -1 + 's'; // start immediately-ish
      const left = Math.random() * 100 + 'vw';
      const opacity = Math.random() * 0.5 + 0.3 + '';
      const size = Math.random() * 1.5 + 0.5 + 'em'; // Random size

      flakes.push({
        style: {
          left: left,
          'animation-duration': duration,
          'animation-delay': delay,
          opacity: opacity,
          'font-size': size,
        },
      });
    }
    this.snowflakes.set(flakes);
  }
}
